import {
  buildFetchById,
  buildFetchForShop,
  buildUpdateModel,
  buildDeleteModel,
  buildCreateModelForShop,
  buildCreateOrUpdateModelForShop,
  buildSearchInShop,
} from '@/models/model-builder'

export default (Model) => {
  if (!Model.fetchById) {
    Model.fetchById = function(id) {
      return buildFetchById(this, id)
    }
  }

  if (!Model.fetchForShop) {
    Model.fetchForShop = function(options) {
      return buildFetchForShop(this, options)
    }
  }

  if (!Model.updateModel) {
    Model.updateModel = function(id, fields) {
      return buildUpdateModel(this, id, fields)
    }
  }
  if (!Model.deleteModel) {
    Model.deleteModel = function(id) {
      return buildDeleteModel(this, id)
    }
  }

  if (!Model.createForShop) {
    Model.createForShop = function(fields) {
      return buildCreateModelForShop(this, fields)
    }
  }

  if (!Model.createOrUpdate) {
    Model.createOrUpdate = function(id) {
      return buildCreateOrUpdateModelForShop(this, id)
    }
  }

  if (!Model.searchInShop) {
    Model.searchInShop = function(options) {
      return buildSearchInShop(this, options)
    }
  }

  const baseFields = Model.fields()
  Model.fields = () => {
    return { ...baseFields, $isNew: Model.boolean(false) }
  }
  return Model
}
